import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface ChartCursor {
  date?: string;
  balance?: number;
}

interface ChartStore {
  cursor?: ChartCursor;
  setCursor: (cursor?: ChartCursor) => void;
  range: number;
  setRange: (range: number) => void;
  compareBalance?: ChartCursor;
  setCompareBalance: (v: ChartCursor) => void;
}

export const useBalanceHistoryStore = create<ChartStore>()(
  devtools((set) => ({
    chartCursor: undefined,
    setCursor: (cursor) => {
      return set({ cursor });
    },
    range: 1,
    setRange: (range) => {
      return set({ range });
    },
    compareBalance: undefined,
    setCompareBalance: (compareBalance) => {
      return set({ compareBalance });
    },
  }))
);
